"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Box = void 0;
const styled_system_1 = require("styled-system");
const styled_1 = __importDefault(require("../../styles/styled"));
const should_forward_prop_1 = __importDefault(require("@styled-system/should-forward-prop"));
exports.Box = (0, styled_1.default)('div', {
    shouldForwardProp: should_forward_prop_1.default,
})({
    minWidth: 0,
}, styled_system_1.space, styled_system_1.layout, styled_system_1.flexbox, styled_system_1.grid, styled_system_1.typography, styled_system_1.border, styled_system_1.position, styled_system_1.shadow, styled_system_1.color);
//# sourceMappingURL=box.js.map